import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import format from '../../helpers/format'
const Styles = require('./Family.css')

@CSSModules(Styles, {allowMultiple:true})
export default class Family extends Component {
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }

  render() {
    if (this.props.location.query.q) {
      let q = this.props.location.query.q
      if (this.props.location.query.q === 'BlackRock/iShares' ||
          this.props.location.query.q === 'BlackRock%2FiShares' ||
          this.props.location.query.q === 'BlackRock%2fiShares') {
        q = 'BlackRock%2FiShares'
      }
      if (this.props.location.query.q === 'TIAA Investments/Nuveen' ||
          this.props.location.query.q === 'TIAA Investments%2FNuveen' ||
          this.props.location.query.q === 'TIAA Investments%2fNuveen') {
        q = 'TIAA Investments%2FNuveen'
      }
      this.context.router.push(config.routes.fundManager + '/' + q)
    } else {
      this.context.router.push(config.routes.fundManagers)
    }
    //
    return <div/>
  }
}
